var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.964355H513V342.957H0V0.964355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.964355H513V114.962H0V0.964355ZM0 228.96H513V342.957H0V228.96Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.028 177.908L256.5 130.327L283.971 177.908H229.028Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.186 193.619L256.5 211.463L220.814 193.619V169.829H292.186V193.619Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.144 132.369L277.528 144.985C282.908 150.368 286.238 157.801 286.238 166.014C286.238 182.438 272.923 195.752 256.5 195.752C240.076 195.752 226.762 182.437 226.762 166.014C226.762 157.803 230.09 150.368 235.472 144.985L222.855 132.369C214.244 140.979 208.918 152.875 208.918 166.013C208.918 192.292 230.22 213.595 256.5 213.595C282.779 213.595 304.081 192.292 304.081 166.013C304.081 152.874 298.755 140.977 290.144 132.369Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.960449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/SV.d2939795656c07d2343f31a22c61a425.svg";
export { ForwardRef as ReactComponent };